import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import {
  C4_VIEW_MODE_LIST,
  isC4ViewMode,
  type C4ViewMode,
} from '../lib/viewModes';

const useStyles = makeStyles(theme => ({
  group: {
    flexWrap: 'wrap',
  },
  button: {
    padding: theme.spacing(0.5, 1.5),
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },
  label: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  badge: {
    fontSize: '0.65rem',
    fontWeight: 700,
    letterSpacing: '0.04em',
    lineHeight: 1.2,
    padding: theme.spacing(0, 0.5),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.secondary,
  },
}));

export interface C4ViewModeSelectorProps {
  value: C4ViewMode;
  onChange: (mode: C4ViewMode) => void;
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

export function C4ViewModeSelector({
  value,
  onChange,
  className,
  size = 'small',
}: C4ViewModeSelectorProps) {
  const classes = useStyles();

  return (
    <ToggleButtonGroup
      exclusive
      size={size}
      value={value}
      className={className ? `${classes.group} ${className}` : classes.group}
      onChange={(_event, next) => {
        if (isC4ViewMode(next) && next !== value) {
          onChange(next);
        }
      }}
      aria-label="Modo de visualização C4"
    >
      {C4_VIEW_MODE_LIST.map(mode => (
        <ToggleButton
          key={mode.id}
          value={mode.id}
          className={classes.button}
          aria-label={mode.label}
        >
          <Tooltip title={mode.description}>
            <Box component="span" className={classes.label}>
              {mode.label}
              {mode.badge && (
                <Box
                  component="span"
                  className={classes.badge}
                  data-testid={`c4-view-mode-badge-${mode.id}`}
                >
                  {mode.badge}
                </Box>
              )}
            </Box>
          </Tooltip>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
